import { Title3, Table, TableBody, TableRow, TableCell, Body1Strong, Body2 } from '@fluentui/react-components';
import { Key16Regular } from '@fluentui/react-icons';
import React from 'react'
import { useTranslation } from 'react-i18next';

interface Steps {
    title: string;
    body: string;
}

const QuickStartTable : React.FC<any> = ({styles}) => {
  const { t } = useTranslation();

  const steps: Steps[] = [
    {
        title: t('info.quickStart.step1.title', 'Choose a Service'),
        body: t('info.quickStart.step1.desc', 'Select from OpenAI, Azure OpenAI, or compatible services based on your needs')
    },
    {
        title: t('info.quickStart.step2.title', 'Get API Credentials'),
        body: t('info.quickStart.step2.desc', 'Follow the instructions below to obtain your API key and endpoint URL')
    },    
    {
        title: t('info.quickStart.step3.title', 'Configure in Settings'),
        body: t('info.quickStart.step3.desc', 'Go to Settings → AI Service Configuration and enter your credentials')
    },
    {
        title: t('info.quickStart.step4.title', 'Start Using'),
        body: t('info.quickStart.step4.desc', 'Return to Home, select data in your worksheet, attach it with the + button, and ask questions about your Excel data')
    },
  ]
  
  return (
      <div className={styles.section}>
        <Title3>
          <Key16Regular className={styles.sectionIcon} />
          {t('info.quickStart.title', 'Quick Start Guide')}
        </Title3>
        <Table className={styles.quickStartTable}>
          <TableBody>
            {steps.map((item, index) => 
                <TableRow key={`${item.title}`}>
                    <TableCell className={styles.stepCell}>
                        <Body1Strong>{index + 1}</Body1Strong>
                    </TableCell>
                    <TableCell>
                        <Body1Strong>{item.title}: </Body1Strong>
                        <Body2>{item.body}</Body2>
                    </TableCell>
                </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
  )
}

export default QuickStartTable;